import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SeoHead = ({
  title,
  description,
  keywords,
  path = '/',
  structuredData
}) => {
  const location = useLocation();

  useEffect(() => {
    const origin = window.location.origin;
    const normalizedPath = location.pathname === '/' ? '/' : location.pathname.replace(/\/$/, '');
    const canonicalUrl = `${origin}${normalizedPath}`;
    const currentPath = location.pathname === '/' ? '/' : location.pathname.replace(/\/$/, '');

    document.title = title;

    const upsertMeta = (name, content, isProperty = false) => {
      const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let element = document.querySelector(selector);

      if (!element) {
        element = document.createElement('meta');
        if (isProperty) {
          element.setAttribute('property', name);
        } else {
          element.setAttribute('name', name);
        }
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    upsertMeta('description', description);
    upsertMeta('keywords', keywords);
    upsertMeta('robots', 'index, follow');
    upsertMeta('og:site_name', 'Ram Homeopathy Clinic', true);
    upsertMeta('og:title', title, true);
    upsertMeta('og:description', description, true);
    upsertMeta('og:type', 'website', true);
    upsertMeta('og:url', canonicalUrl, true);
    upsertMeta('twitter:site', '@ramhomeopathy');
    upsertMeta('twitter:card', 'summary');
    upsertMeta('twitter:title', title);
    upsertMeta('twitter:description', description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);

    const scriptId = 'seo-structured-data';
    const oldScript = document.getElementById(scriptId);
    if (oldScript) {
      oldScript.remove();
    }

    if (structuredData && currentPath === normalizedPath) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, path, structuredData, location.pathname]);

  return null;
};

export default SeoHead;
